<template>
    <div
        id="accessibilityTable"
        class="2xl:pt-10"
    >
        <h3 class=" has-text-centered text-black font-medium text-xl md:text-2xl mb-6 2xl:mb-20">
            Non-raw material selection
        </h3>
        <div class="w-11/12 xl:w-4/5 mx-auto ">
            <div class="overflow-x-auto md:w-3/4 mx-auto">
                <table class="table is-fullwidth center-table accessibility-table min-w-full w-full">
                    <tbody>
                        <tr>
                            <td class="">Drinking water pH</td>
                            <td class="">
                                <slider
                                    id="waterPHSlider"
                                    type="info"
                                    size="medium"
                                    borderColor= "#45AC34"
                                    :value="Number(model.waterPH)"
                                    :min="4"
                                    :max="8"
                                    :step="1"
                                    is-fullwidth
                                    @change="updateWaterPH"
                                ></slider>
                            </td>
                            <td><input
                                    class="input"
                                    type="number"
                                    v-model="model.waterPH"
                                    min="4"
                                    max="8"
                                    number
                                ></td>
                        </tr>
                        <tr>
                            <td>Drinking water temperature (C)</td>
                            <td>
                                <slider
                                    id="waterTemperatureSlider"
                                    type="info"
                                    size="medium"
                                    borderColor= "#45AC34"
                                    :value="Number(model.waterTemp)"
                                    :min="3"
                                    :max="38"
                                    :step="1"
                                    is-fullwidth
                                    @change="updateWaterTemp"
                                ></slider>
                            </td>
                            <td><input
                                    class="input"
                                    type="number"
                                    v-model="model.waterTemp"
                                    min="3"
                                    max="38"
                                    number
                                ></td>
                        </tr>
                        <tr>
                            <td>Dietary Cl (%)</td>
                            <td>
                                <slider
                                    id="waterTemperatureSlider"
                                    type="info"
                                    size="medium"
                                    borderColor= "#45AC34"
                                    :value="Number(model.dietaryCl)"
                                    :min="0.18"
                                    :max="0.40"
                                    :step="0.01"
                                    is-fullwidth
                                    @change="updateDietaryCl"
                                ></slider>
                            </td>
                            <td><input
                                    class="input"
                                    type="number"
                                    v-model="model.dietaryCl"
                                    min="0.18"
                                    max="0.40"
                                    step="0.01"
                                    number
                                ></td>
                        </tr>
                        <tr>
                            <td>Protease (ProAct, ProAct360)</td>
                            <td>
                                <toggle-button
                                    class="tglFontSize"
                                    :width="80"
                                    :height="38"
                                    v-model="model.protease"
                                    :color="{checked: '#45AC34', unchecked: '#DFE7F4'}"
                                    :sync="true"
                                />
                            </td>
                            <td v-text="getYesNo(model.protease)"></td>
                        </tr>
                        <tr>
                            <td>Carbohydrase (WX2,000, MultiGrain, VP, HiStrach)</td>
                            <td>
                                <toggle-button
                                    class="tglFontSize"
                                    :width="80"
                                    :height="38"
                                    v-model="model.carbohydrase"
                                    :color="{checked: '#45AC34', unchecked: '#DFE7F4'}"
                                    :sync="true"
                                />
                            </td>
                            <td v-text="getYesNo(model.carbohydrase)"></td>
                        </tr>
                        <tr>
                            <td>Acidifier in water or feed</td>
                            <td>
                                <toggle-button
                                    class="tglFontSize"
                                    :width="80"
                                    :height="38"
                                    v-model="model.acidifier"
                                    :color="{checked: '#45AC34', unchecked: '#DFE7F4'}"
                                    :sync="true"
                                />
                            </td>
                            <td v-text="getYesNo(model.acidifier)"></td>
                        </tr>
                        <tr>
                            <td>Pharmaceutical Zn or Cu</td>
                            <td>
                                <toggle-button
                                    class="tglFontSize"
                                    :width="80"
                                    :height="38"
                                    v-model="model.znOrCu"
                                    :color="{checked: '#45AC34', unchecked: '#DFE7F4'}"
                                    :sync="true"
                                />
                            </td>
                            <td v-text="getYesNo(model.znOrCu)"></td>
                        </tr>
                        <tr>
                            <td>Diet Total Ca (%)</td>
                            <td>
                                <slider
                                    id="dietCaSlider"
                                    type="info"
                                    size="medium"
                                    borderColor= "#45AC34"
                                    :value="Number(model.dietCa)"
                                    :min="totalCaDefaults.min"
                                    :max="totalCaDefaults.max"
                                    :step="totalCaDefaults.step"
                                    is-fullwidth
                                    @change="updateDietCa"
                                ></slider>
                            </td>
                            <td><input
                                    class="input"
                                    type="number"
                                    v-model="model.dietCa"
                                    :min="totalCaDefaults.min"
                                    :max="totalCaDefaults.max"
                                    :step="totalCaDefaults.step"
                                    number
                                ></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="bg-gray-600">
            <div class="mt-10 2xl:mt-20 w-11/12 md:w-3/5 mx-auto">
                <div class="flex items-center py-4 sl:py-6 2xl:py-10 border-b border-solid border-gray-400">
                    <h3 class="text-lg md:text-xl font-medium text-black w-3/4">Corrected Accessibility Factor</h3>
                    <div v-text="this.roundedCorrectedAccessibility * 100 + '%'" class="text-2xl md:text-3xl font-bold text-brand-100 ml-6 md:ml-0"></div>
                </div>
                <div class="flex items-center py-4 sl:py-6 2xl:py-10">
                    <h3 class="text-lg md:text-xl font-medium text-black w-3/4">Reactive/Soluble Phytate P Estimate</h3>
                    <div v-text="this.roundedCorrectedPhytateP + '%'" class="text-2xl md:text-3xl font-bold text-brand-100 ml-6 md:ml-0"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Slider from "./Slider";
import ToggleButton from "vue-js-toggle-button/src/Button";
import { CALCIUM_DEFAULTS } from '../utilities/application';

export default {
    props: ["totalPhytateP", "accessiblePhytateP", "accessiblePhytatePCalculated", "defaultValue", "calculatedDefaultValue", "useDefault", "animal", "selectedProductVersion"],
    components: {
        Slider,
        ToggleButton
    },
    data() {
        return {
            model: {
                waterPH: 7,
                waterTemp: 10,
                dietaryCl: 0.27,
                protease: false,
                carbohydrase: false,
                acidifier: false,
                znOrCu: false,
                dietCa: CALCIUM_DEFAULTS['totalCa'].default,
                dietCP: 20
            }
        };
    },
    created() {
       this.$emit("accessibilityUpdated", {
            correctedAccessibility: this.correctedAccessibility
        });
    },
    computed: {
        waterPhFactor() {
            return _.round((-(this.model.waterPH - 7) / this.model.waterPH) * 3 * 100, 2);
        },
        waterTempFactor() {
            return _.round(
                ((this.model.waterTemp - 10) / this.model.waterTemp) * 0.3 * 100,
                2
            );
        },
        dietaryClFactor() {
            return _.round(((this.model.dietaryCl - 0.27) / this.model.dietaryCl) * 100, 2);
        },
        proteaseFactor() {
            return this.model.protease ? 0.5 * 100 : 0;
        },
        carbohydraseFactor() {
            return this.model.carbohydrase ? 0.5 * 100 : 0;
        },
        acidifierFactor() {
            return this.model.acidifier ? 0.8 * 100 : 0;
        },
        znOrCuFactor() {
            return this.model.znOrCu ? -0.8 * 100 : 0;
        },
        // dietCaFactor() {
        //     return _.round((-(this.model.dietCa - CALCIUM_DEFAULTS['totalCa'].default) / this.model.dietCa) * 6 * 100, 2);
        // },
        dietCaFactor() {
            if (this.selectedProductVersion === 'hiphos') {
                return _.round((-(this.model.dietCa - CALCIUM_DEFAULTS['totalCa'].default) / this.model.dietCa) * 6 * 100, 2);
            } else {
                let x = this.model.dietCa;
                const y = _.round(((-390 + 1266 * x - (896*(x*x)))) * 3, 2);
                return y;
            }
        },
        phytateCP() {
            return _.round(
                ((this.accessiblePhytateP / 0.282) * 1000) / (this.model.dietCP * 10),
                4
            );
        },
        phytateCPFactor() {
            return _.round(
                (-(this.phytateCP - 0.04) / this.phytateCP) * 3 * 100,
                2
            );
        },
        caPhytateP() {
            return _.round(this.model.dietCa / (this.accessiblePhytateP * 100), 4);
        },
        caPhytatePFactor() {
            return _.round(
                (-(this.caPhytateP - 3) / this.caPhytateP) * 10 * 100,
                2
            );
        },
        average() {
            return _.round(
                (this.waterPhFactor +
                    this.waterTempFactor +
                    this.dietaryClFactor +
                    this.proteaseFactor +
                    this.carbohydraseFactor +
                    this.acidifierFactor +
                    this.znOrCuFactor +
                    this.dietCaFactor) /
                    8,
                2
            );
        },
        correctedPhytateP() {
            return !this.useDefault ? (
                (this.average / 100) *
                    (this.totalPhytateP - this.accessiblePhytatePCalculated) +
                this.accessiblePhytatePCalculated
            ) : this.accessiblePhytateP;
        },
        roundedCorrectedPhytateP() {
            return _.round(this.correctedPhytateP, 3);
        },
        correctedAccessibility() {
            let calculatedAccessibility = (this.defaultValue * 100 + 0.2 * this.average) / 100;
            return calculatedAccessibility
            // return this.phytateCP >= 4.00 && this.phytateCP <= 6.00 ? calculatedAccessibility - 0.02 : calculatedAccessibility;
        },
        roundedCorrectedAccessibility() {
            return _.round(this.correctedAccessibility, 2);
        },
        totalCaDefaults() {
            return this.animal === "Swine" ? CALCIUM_DEFAULTS['totalCaSwine'] : CALCIUM_DEFAULTS['totalCa']
        },
    },

    watch: {
        correctedPhytateP: function() {
            this.$emit("correctedPhytatePUpdated", {
                correctedPhytateP: this.correctedPhytateP
            });
        },
        correctedAccessibility: function() {
            this.$emit("accessibilityUpdated", {
                correctedAccessibility: this.correctedAccessibility
            });
        },
        model: {
            handler(val){
                EventHub.$emit("accessibilityPropertiesUpdated", this.model);
            },
            deep: true
        },
        useDefault: function(){
            EventHub.$emit("accessibilityPropertiesUpdated", {
                useDefault: this.useDefault,
                ...this.model
            });
        },
        animal() {
            this.model.dietCa = this.totalCaDefaults.default;
        }
    },

    methods: {
        updateWaterPH(val) {
            this.model.waterPH = Number(val);
        },
        updateWaterTemp(val) {
            this.model.waterTemp = Number(val);
        },
        updateDietaryCl(val) {
            this.model.dietaryCl = Number(val);
        },
        updateDietCa(val) {
            this.model.dietCa = Number(val);
        },
        updateDietCP(val) {
            this.model.dietCP = Number(val);
        },
        getYesNo(booleanValue) {
            return booleanValue ? "Yes" : "No";
        },
    }
};
</script>
<style type="text/css">
#accessibilityTable th {
    text-align: center;
}
#accessibilityTable .tglFontSize {
    font-size: 16px;
}
</style>
